import { Button, Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useState } from 'react';
import {
  Typography,
  TextField,
  Autocomplete,
  LinearProgress,
  CircularProgress,
  CardHeader,
  FormControl,
  FormLabel,
} from '@mui/material';
import useAfasData from '../hooks/useAfasData';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

function DebtorSelector({ setPartOneComplete, partOneComplete, setSelectedDebtor: setDefSelectedDebtor }) {
  const [value, setValue] = useState(dayjs());
  const [selectedDebtor, setSelectedDebtor] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const {
    data: debtorData = [],
    isLoading: debtorDataLoading,
    errorMessage: debtorDataErrorMessage,
  } = useAfasData('/salesrelation', {});

  // Prepare options once for the Autocomplete component
  const options = debtorData.map((d) => ({
    label: d.Naam_orgper,
    id: d.Nummer_debiteur,
    searchData: `${d.Naam_orgper} ${d.Nummer_debiteur}`, // Combined search field
  }));

  // Button should be enabled only if both a debtor and date are selected
  const isFormComplete = selectedDebtor !== null && value !== null;

  return (
    <>
      {debtorDataLoading && <LinearProgress mt={2} />}
      <Card sx={{ overflow: 'unset' }}>
        <CardHeader title="Stap 1. Selecteer een debiteur" slotProps={{ title: { variant: 'h2' } }} />
        <CardContent>
          <Grid container spacing={4}>
            <Grid size={6}>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 1 }}>Selecteer verkooprelatie</FormLabel>
                {debtorDataLoading && <LinearProgress />}
                {!debtorDataLoading && debtorData.length !== 0 && (
                  <Autocomplete
                    fullWidth
                    disabled={partOneComplete}
                    options={options}
                    loading={debtorDataLoading}
                    noOptionsText="Geen verkooprelatie gevonden"
                    value={selectedDebtor}
                    onChange={(event, newValue) => setSelectedDebtor(newValue)}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.label} ({option.id})
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Debiteur"
                        variant="filled"
                        value={inputValue}
                        sx={{
                          '&::before': {
                            content: 'unset',
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {debtorDataLoading ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                )}
              </FormControl>
            </Grid>

            <Grid size={6}>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 1 }}>Selecteer datum</FormLabel>
                <DatePicker
                  value={value}
                  disabled={partOneComplete}
                  onChange={(newValue) => setValue(newValue)}
                  fullWidth
                  slotProps={{
                    textField: {
                      variant: 'filled',
                      label: 'Datum',
                    },
                  }}
                />
              </FormControl>
            </Grid>

            {/* If there is no data or an error */}
            {!debtorDataLoading && debtorData.length === 0 && (
              <Grid size={12}>
                <Typography align="center" variant="h6">
                  No results
                </Typography>
              </Grid>
            )}
            {debtorDataErrorMessage && (
              <Grid size={12}>
                <Typography align="center" variant="h6">
                  {debtorDataErrorMessage}
                </Typography>
              </Grid>
            )}

            {/* Button to load the next form step */}
            <Grid size={12}>
              <Button
                variant="contained"
                color="primary"
                disabled={!isFormComplete}
                onClick={() => {
                  console.log('Proceed to next step');
                  setDefSelectedDebtor(selectedDebtor);
                  setPartOneComplete(true);
                }}
              >
                Volgende stap
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

export default DebtorSelector;
